import { useTranslation } from 'next-i18next';
import { BoltFillColorVioletIcon } from '@/icons';
export const Titles = () => {
  const {
    t
  } = useTranslation(['common']);
  return <div className="flex flex-col items-center gap-xs" data-sentry-component="Titles" data-sentry-source-file="Titles.tsx">
      <BoltFillColorVioletIcon size="xl" data-sentry-element="BoltFillColorVioletIcon" data-sentry-source-file="Titles.tsx" />
      <h2 className="text-heading-xl-extrabold">
        {t('common:upselling.premiumFeatures')}
      </h2>
      <p className="text-center text-body-md-semibold text-neutral">
        {t('common:upselling.premiumDescription')}
      </p>
    </div>;
};